<template>
  <b-navbar type="dark" class="navbar" toggleable="md" sticky>
    <button @click="openMenu" class="navbar__menu-button">
      <img src="../../files/header-icon.png" class="navbar-icon" />
    </button>
    <b-navbar-brand class="logo-group" to="/">
      <img src="../../files/footer-logo1.png" class="navbar-logo" />
      FireRisks
    </b-navbar-brand>
    <b-navbar-toggle v-if="$auth.check()" target="nav_collapse" />
    <b-collapse v-if="$auth.check()" is-nav id="nav_collapse">
      <b-navbar-nav class="ml-auto nav-list">
        <li class="nav-item">
          <button @click="openCitiesModal" class="nav-link">Справочники</button>
        </li>

        <li class="nav-item">
          <button @click="openSubstancesModal" class="nav-link">База материалов</button>
        </li>

        <li class="nav-item">
          <!-- Пока нет метода у бекенда, отключаем встроенную форму поддержки -->
          <!-- <a class="nav-link" href="#" v-b-modal.support>Поддержка</a> -->
          <a class="nav-link" href="https://mst.su/company/feedback/" target="_blank">Поддержка</a>
        </li>

        <li v-if="$auth.user().isAdmin || $auth.user().isMst" class="nav-item-icon nav-item-icon_optional">
          <button @click="$router.push('/admin')" id="admin-button" class="navbar-admin-button">
            <img class="navbar-admin-icon" src="../../files/admin-icon.svg" alt="admin icon" />
          </button>
          <main-tooltip target="admin-button" tooltipValue="Административная зона" />
        </li>

        <li class="nav-item-icon">
          <notification-button @click="showNewsMenu" :withNotification="withNotification" />
        </li>

        <li class="nav-item-icon">
          <avatar-button @click="openLkModal" @mouseenter="showNewsMenu" />
        </li>
      </b-navbar-nav>
    </b-collapse>

    <!-- Меню проектов -->
    <menu-modal
      hideHeader
      body-class="navbar__menu-body"
      modal-class="navbar__menu-modal"
      dialog-class="navbar__menu-dialog"
      id="navbar-menu"
    >
      <projects-menu />
    </menu-modal>

    <!-- Форма технической поддержки -->
    <support-modal />

    <!-- <b-modal v-if="$auth.check()" >
      <tickets></tickets>
    </b-modal> -->

    <substances-modal v-if="$auth.check()" />

    <b-modal v-if="$auth.check()" id="cities-modal" size="xl" hide-footer title="Редактор городов">
      <cities />
    </b-modal>

    <menu-modal
      v-if="$auth.check()"
      wrapperClass="user-menu-wrapper"
      withoutBackdrop
      title="Уведомления"
      body-class="user-menu-body"
      modal-class="user-menu"
      id="user-news-menu"
      @closeClick="hideNewsMenu"
    >
      <div class="user-menu-content">
        <ul class="user-menu-list">
          <li class="user-menu-list-item">
            <img class="user-menu-list-icon" src="../../files/mail-icon.svg" alt="иконка меню" />
            <div class="user-menu-list-text-block">
              <div class="user-menu-list-text-block-line">
                <main-text>Новое сообщение</main-text>
                <main-text color="grey-2" class="user-menu-list-time">1ч назад</main-text>
              </div>
              <button class="user-menu-list-button">
                <main-text color="primary" mode="button" class="user-menu-list-time">Посмотреть</main-text>
              </button>
            </div>
          </li>

          <li class="user-menu-list-item">
            <img class="user-menu-list-icon" src="../../files/info-icon.svg" alt="иконка меню" />
            <div class="user-menu-list-text-block">
              <div class="user-menu-list-text-block-line">
                <main-text>Последние новости</main-text>
                <main-text v-if="news.length" color="grey-2" class="user-menu-list-time">{{
                  parseInt(news[0].date) | moment("from", "now")
                }}</main-text>
              </div>
              <button @click="openNewsModal" class="user-menu-list-button">
                <main-text color="primary" mode="button" class="user-menu-list-time">Посмотреть</main-text>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </menu-modal>

    <menu-modal
      v-if="$auth.check()"
      hideHeader
      withoutBackdrop
      body-class="lk-menu-body"
      modal-class="lk-menu"
      id="lk-menu"
      @closeClick="() => {}"
    >
      <div class="lk-menu-content">
        <ul>
          <li v-if="$auth.user().isAdmin" class="lk-menu-list-item">
            <button @click="handleAddNews" class="lk-menu-button">
              <main-text mode="button">Добавить новость</main-text>
            </button>
          </li>

          <li @click="closeLkModal()" class="lk-menu-list-item">
            <router-link to="/account" class="lk-menu-button">
              <main-text mode="button">Личный кабинет</main-text>
            </router-link>
          </li>

          <li class="lk-menu-list-item">
            <button
              class="lk-menu-button"
              @click.prevent="
                closeLkModal();
                logout();
              "
            >
              <main-text mode="button">Выйти</main-text>
            </button>
          </li>
        </ul>
      </div>
    </menu-modal>

    <div v-if="isOverlayOpened" @click="hideNewsMenu" class="user-menu-overlay" />

    <news-modal @addNewsButtonClick="handleAddNews" :news="news" />
    <news-add-modal @newsAdded="handleNewsAdded" />
  </b-navbar>
</template>

<!-- eslint-disable no-console -->
<script>
import substancesModal from "../../views/risks/substancesModal.vue";
import cities from "../../views/risks/cities/cities.vue";
import AvatarButton from "../ui/AvatarButton.vue";
import NotificationButton from "../ui/NotificationButton.vue";
import MenuModal from "../modals/MenuModal.vue";
import Text from "../ui/Text.vue";
import NewsModal from "../modals/NewsModal.vue";
import NewsAddModal from "../modals/NewsAddModal.vue";
import MainTooltip from "../ui/MainTooltip.vue";
import SupportModal from "../modals/SupportModal.vue";
import ProjectsMenu from "../ProjectsMenu.vue";

export default {
  name: "navbar",
  data() {
    return {
      buzy: false,
      news: [],
      form: {
        title: "",
        message: "",
        cities,
      },
      timeout: null,
      isOverlayOpened: false,
    };
  },
  props: {
    withNotification: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    "substances-modal": substancesModal,
    cities,
    AvatarButton,
    MenuModal,
    "main-text": Text,
    NewsModal,
    NewsAddModal,
    NotificationButton,
    MainTooltip,
    SupportModal,
    ProjectsMenu,
  },
  computed: {
    isUserAuth() {
      return this.$auth.check();
    },
  },
  watch: {
    isUserAuth() {
      if (this.isUserAuth) {
        this.fetchNews();
      }
    },
  },
  methods: {
    onSubmit() {
      this.buzy = true;
      this.$http
        .post("user/support", this.form)
        .then(() => {
          alert("Ваше обращение отправлено");
          this.buzy = false;
          this.$refs.support.hide();
        })
        .catch(() => {
          alert("Возникла ошибка при отправке сообщения");
          this.buzy = false;
        });
    },

    logout() {
      this.$auth.logout({
        makeRequest: true,
        redirect: "/login",
        success() {
          console.log("success " + this.context);
        },
        error() {
          console.log("error " + this.context);
        },
      });
    },

    openSubstancesModal() {
      this.$bvModal.show("substances-modal");
    },

    openCitiesModal() {
      this.$bvModal.show("cities-modal");
    },

    showNewsMenu() {
      this.isOverlayOpened = true;
      this.$bvModal.show("user-news-menu");
    },

    hideNewsMenu() {
      this.isOverlayOpened = false;
      this.$bvModal.hide("user-news-menu");
    },
    handleAvatarClick() {
      this.hideNewsMenu();
    },

    fetchNews() {
      this.$http
        .get("profile/news-get")
        .then((response) => {
          this.newsLoading = false;
          this.news = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },

    openNewsModal() {
      this.$bvModal.show("news-modal");
    },

    handleAddNews() {
      this.$bvModal.show("news-add-modal");
    },

    openProfileModal() {
      this.$bvModal.show("modal-settings");
    },

    openLkModal() {
      this.hideNewsMenu();
      this.$bvModal.show("lk-menu");
    },
    closeLkModal() {
      this.$bvModal.hide("lk-menu");
    },
    openMenu() {
      this.$bvModal.show("navbar-menu");
    },
    handleNewsAdded() {
      this.fetchNews();
    },
  },
};
</script>

<style>
.navbar {
  background-color: var(--primary-color);
  padding: 5px 32px;
}

.navbar__menu-modal {
  position: absolute;
  top: 32px;
  left: 32px;
}
.navbar__menu-dialog {
  max-width: 500px;
}
.navbar__menu-button {
  padding: 0;
  border: none;
  background-color: transparent;
  width: fit-content;
  height: fit-content;
  margin-right: 16px;
  display: flex;
  align-items: center;
}

.navbar__menu-body {
  width: fit-content;
  padding: 0;
}

@media screen and (max-width: 768px) {
  .navbar {
    padding: 5px 16px;
  }
}

.logo-group {
  display: flex;
  align-items: center;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
}

.logo-group:hover {
  color: rgba(255, 255, 255, 0.75);
}

.navbar-icon {
  width: 16px;
  height: 16px;
}

.navbar-logo {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}

.nav-item {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  margin-right: 40px;
}

.nav-item:last-of-type {
  margin-right: 0;
}

@media screen and (max-width: 767px) {
  .nav-item {
    margin-right: 0;
    margin-bottom: 16px !important;
  }
}

.nav-item-icon {
  margin-left: 80px;
  margin-right: 16px;
}

.nav-item-icon:last-of-type {
  margin: 0;
}

.nav-item-icon_optional {
  margin-right: -64px;
  opacity: 1;
  transition: opacity 0.15s ease-out;
}

.nav-item-icon_optional:hover {
  opacity: 0.75;
}

@media screen and (max-width: 900px) {
  .nav-item-icon {
    margin-left: 30px;
  }
  .nav-item-icon_optional {
    margin-right: -14px;
  }
}

@media screen and (max-width: 767px) {
  .nav-item-icon {
    margin: 0 0 16px;
  }
}

.nav-list {
  display: flex;
  align-items: center;
}

.navbar .nav-link {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  /* Перебиваем стили библиотеки */
  color: #fff !important;
  height: auto;
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0 !important;
  transition: color 0.3s ease-out;
}

.navbar .nav-link:hover {
  color: rgba(255, 255, 255, 0.75) !important;
}

.user-menu {
  position: absolute;
  width: 410px;
  right: 10px;
  top: 60px;
  margin: 0;
}

@media screen and (max-width: 768px) {
  .user-menu {
    top: 212px;
  }
}

.user-menu-wrapper {
  pointer-events: none;
}

.user-menu-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.lk-menu {
  position: absolute;
  width: 160px;
  right: 10px;
  top: 60px;
  margin: 0;
}

@media screen and (max-width: 768px) {
  .lk-menu {
    top: 212px;
  }
}

.lk-menu-list-item {
  padding-bottom: 12px;
  border-bottom: 1px solid var(--grey-color);
  margin-top: 12px;
}

.lk-menu-list-item:first-of-type {
  margin-top: 0;
}

.lk-menu-list-item:last-of-type {
  border-bottom: none;
  padding-bottom: 0;
}

.lk-menu-button {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  border: none;
  padding: 0;
  cursor: pointer;
  background-color: transparent;
}

.navbar-admin-button {
  border: none;
  padding: 0;
  background: transparent;
}
</style>
